import type { IconProps } from './types';

export const DotsHorizontalIcon = (props: IconProps) => {
  const { color = 'currentColor', size = 24, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path d="M3 11H5V13H3V11Z" fill={color} />
      <path d="M11 11H13V13H11V11Z" fill={color} />
      <path d="M19 11H21V13H19V11Z" fill={color} />
      <path d="M3 11H5V13H3V11Z" stroke={color} strokeWidth="2" />
      <path d="M11 11H13V13H11V11Z" stroke={color} strokeWidth="2" />
      <path d="M19 11H21V13H19V11Z" stroke={color} strokeWidth="2" />
    </svg>
  );
};
